import { FC } from 'react'
import { Icon } from '../../../../shared'
import { getV3ColorCssVariable } from '../../../../../design-system/colors_v3'
import { ExternalResourceLinkProps } from './ExternalResourceLink.model'
import styles from './ExternalResourceLink.module.scss'

export const ExternalResourceLink: FC<ExternalResourceLinkProps> = ({
  label,
  shrink = false,
  onClick,
}) => {
  return (
    <div className={styles.externalResourceLink} onClick={onClick}>
      {!shrink && <span className={styles.externalResourceLinkLabel}>{label}</span>}
      <Icon
        color={getV3ColorCssVariable('primary', 'default')}
        icon="infoCircle"
        size={shrink ? 'normal' : 'nano'}
      />
    </div>
  )
}
